<template>
  <div>
    <Head title="Klinika Przyczynowego Leczenia Niepłodności" />
    <template v-for="(item, index) in sortedPageLayout" :key="index">
      <DynamicBlock
        v-if="item.type === 'block' && item.block"
        :block="item.block"
      />
    </template>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import DynamicBlock from '@/Shared/DynamicBlock.vue';

export default {
  components: { Head, DynamicBlock },
  layout: Layout,
  props: {
    pageLayout: { type: Array, default: () => [] },
  },
  computed: {
    sortedPageLayout() {
      return [...this.pageLayout].sort((a, b) => (a.order || 0) - (b.order || 0));
    },
  },
};
</script>
